// Formatação dos valores monetários vindos da API — número ou string decimal.
// O que não for um número finito (null, '', NaN) mostra-se como 0.00.
export const formatPrice = (price) => {
  const value = typeof price === 'number' ? price : parseFloat(price);
  return Number.isFinite(value) ? value.toFixed(2) : '0.00';
};

// A percentagem de IVA é a que a API devolveu; sem ela, rótulo sem percentagem.
export const taxLabel = (totals) =>
  totals && typeof totals.taxRate === 'number'
    ? `IVA (${(totals.taxRate * 100).toFixed(0)}%)`
    : 'IVA';

// Enquanto os totais não chegam não se mostram valores — nunca valores errados.
export const renderAmount = (amount, { loading, totals }) =>
  loading || !totals ? '—' : `${formatPrice(amount)}€`;
